/**
 * Feature flag helpers for Accelerator frontend.
 */

/**
 * Checks whether the Reports UI feature flag is enabled.
 * Defaults to false unless VITE_FEATURE_REPORTS is set to "true".
 */
export function isReportsFeatureEnabled(): boolean {
  return import.meta.env?.VITE_FEATURE_REPORTS === "true";
}
